import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../../components/PublicLayout';
import '../../styles/AboutPage.css';

export default function AboutPage() {
  const values = [
    {
      title: "Customer-Centric Innovation",
      description: "We build technology that solves real problems for sales teams, always listening and iterating based on customer feedback."
    },
    {
      title: "Ethical AI",
      description: "We develop AI responsibly, prioritizing transparency, fairness, and privacy in everything we build."
    },
    {
      title: "Excellence in Execution",
      description: "We're committed to building high-quality, reliable products that teams can depend on every day."
    },
    {
      title: "Continuous Learning",
      description: "We maintain a growth mindset, constantly learning and evolving our approach as technology and markets change."
    }
  ];

  return (
    <PublicLayout>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Velox AI</h1>
          <p>Transforming B2B sales with artificial intelligence</p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="about-story">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <h2>Our Story</h2>
              <p>Velox AI was founded after we saw firsthand the challenges that B2B sales teams face in today's complex selling environment. With backgrounds in sales, marketing, and artificial intelligence, we recognized an opportunity to transform how sales teams work by applying cutting-edge AI to the sales process.</p>
              
              <p>The name "Velox" comes from the Latin word for "swift," reflecting our mission to help sales teams work faster and more effectively. We launched our first product in 2025 and have been rapidly growing our customer base and product capabilities since then.</p>
              
              <p>Today, Velox AI aims to serve B2B companies, helping their sales teams close more deals with less effort through our comprehensive AI-powered revenue operations intelligence platform.</p>
            </div>
            
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="about-values">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <p className="section-subtitle">The principles that guide everything we do</p>
          
          <div className="values-grid">
            {values.map((value, index) => (
              <div className="value-card" key={index}>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="cta-background">
          <div className="cta-gradient"></div>
          <div className="cta-particles"></div>
        </div>
        
        <div className="container">
          <h2>Ready to Bring Ambient Intelligence to Your Sales?</h2>
          <p>Equip your revenue team with always-on insights, seamless workflows, and deal intelligence that moves at the speed of your buyers</p>
          
          <div className="cta-buttons">
            <Link to="/waitlist" className="btn btn-primary btn-large">Create Account</Link>
            <Link to="/contact" className="btn btn-secondary">Contact Our Team</Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
} 